export const TAX = 'Taxs';
export const TAX_ADD = 'Taxs_add';
export const TAX_DELETE = 'Taxs_deleted';
export const TAX_EDIT = 'Taxs_edit';

export const TAX_SETROWDATA = 'Taxs_set_rowdata';
export const MODEL_OPEN = 'Taxs_model_open';
export const MODEL_CLOSE = 'Taxs_model_close';

export const TAX_LIST_SUCCESSFUL = 'Taxs_list_successfull';
export const TAX_ADD_SUCCESSFUL = 'Taxs_add_successfull';
export const TAX_EDIT_SUCCESSFUL = 'Taxs_edit_successfull';

export const API_ERROR = 'api_failed';
